module.exports = __webpack_public_path__ + "img/decor-point.f49f3d25.svg";